document.addEventListener('DOMContentLoaded', () => {
    
    // ------------------------------------
    // 【新規追加】文字分割処理
    // ------------------------------------
    const charSlideElements = document.querySelectorAll('.animate-char-slide');
    
    charSlideElements.forEach(element => {
        const text = element.textContent.trim().replace(/[\n\r\t]/g, '');
        
        element.innerHTML = text.split('').map((char, index) => {
            const content = (char === ' ') ? '&nbsp;' : char;
            return `<span style="transition-delay: ${index * 0.05}s">${content}</span>`;
        }).join('');
    });
    
    // ------------------------------------
    // Intersection Observerによる監視対象設定
    // ------------------------------------
    const fadeElements = document.querySelectorAll(
        '.blur-in-animation, .animate-fade-up, .animate-char-slide span' 
    ); 
    
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1 
    };

    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    fadeElements.forEach(element => {
        observer.observe(element);
    });

});